export default "__VITE_ASSET__BmuA6PX4__"